import { useMemo } from "react";
import { getTodayQatarRange, QATAR_TZ } from "@/utils/timezone";

export function useTodayWindow() {
  return useMemo(() => {
    // Use Qatar day boundaries (midnight Qatar = 21:00 UTC previous day)
    const { start, end } = getTodayQatarRange();
    const result = { fromISO: start, toISO: end, tz: QATAR_TZ };
    return result;
  }, []);
}

export type TodayWindow = ReturnType<typeof useTodayWindow>;


